module.exports = "div {\n  margin-top: 15px;\n  color: #dedede;\n}\n"